import { Navigate } from "react-router";
import { usePaths } from "../../paths.ts";

export function NavigateToDefaultPage() {
    const { home } = usePaths();

    return <Navigate to={home} replace />;
}
